import React, { useEffect } from "react";
import {
    Box,
    Button,
    Flex,
    FormLabel,
    Heading,
    Input,
    Text,
    Textarea,
} from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
    closeAddPaymentSubject,
} from "../../../../modules/admin-modules/models/Actions";
import MainModel from "../../../../components/Models/main-model";
import { useForm } from "react-hook-form";
import MainInput from "../../../../components/Form/input";
import Select from "react-select";
import { toast } from "react-toastify";
import { useState } from "react";
import { addPaymentSubjectRequest, editPaymentSubjectRequest } from "../../../../modules/admin-modules/videos/Actions";

const AddPaymentSubject = ({ isAdd, data, setSelectedData }) => {
    const openChapter = useSelector((state) => state.model.isOpen35);
    const isLoading = useSelector((state) => state.adminSections.isLoading);

    const dispatch = useDispatch();
    useEffect(() => { }, []);

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm({
        defaultValues: !isAdd ? data : {},
        shouldUnregister: true,
    });

    const header = (
        <Box>
            <Heading textAlign="center" color="main_1" fontSize="24px">
                {isAdd ? " إضافة الفصل" : "تعديل  الفصل"}
            </Heading>
        </Box>
    );
    const onSubmit = async (values) => {
        const action = () => {
            dispatch(closeAddPaymentSubject());
            setSelectedData({});
            reset();
        };
        if (isAdd) {
            let formData = await new FormData();
            formData.append("name", values?.name);
            formData.append("value", values?.value);
            console.log(values);

            await dispatch(addPaymentSubjectRequest(formData, action));
        } else {

            dispatch(
                editPaymentSubjectRequest({
                    id: data?.id,
                    formData: {
                        name: values?.name,
                        value: parseInt(values?.value, 10) || 0
                    },
                    action: action,
                })
            );
        }
    };
    const closeFunc = () => {
        dispatch(closeAddPaymentSubject());
        setSelectedData({});
        reset();
    };
    return (
        <MainModel
            isLoading={isLoading}
            header={header}
            closeFunc={closeFunc}
            openVar={openChapter}
            buttonTitle={" حفظ التغيرات"}
            buttonFunc={handleSubmit(onSubmit)}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <Flex
                    dir="rtl"
                    w="100%"
                    flexWrap="wrap"
                    justifyContent="space-between"
                    gap="4"
                >
                    <Box w="45%">
                        <MainInput
                            label="اسم الدفع"
                            defaultValues={data?.name}
                            error={errors?.name?.message}
                            placeholder="ادخل اسم الدفع "
                            register={register}
                            name="name"
                        />
                    </Box>
                    <Box w="45%">
                        <MainInput
                            label="قيمة الدفع"
                            defaultValues={data?.value}
                            error={errors?.name?.message}
                            placeholder="ادخل قيمة الدفع "
                            register={register}
                            name="value"
                        />
                    </Box>
                </Flex>
            </form>
        </MainModel>
    );
};

export default AddPaymentSubject;
